import { Filter } from 'lucide-react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

import { Button } from '@/common/components/ui/button';

interface FilterButtonProps extends ComponentPropsWithoutRef<'button'> {
  hasActiveFilter: boolean;
}

export const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ hasActiveFilter, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        variant="ghost"
        size="sm"
        className={`h-6 w-6 p-0 ${hasActiveFilter ? 'text-primary' : ''}`}
        {...props}
      >
        <Filter className="h-3.5 w-3.5" />
      </Button>
    );
  },
);

FilterButton.displayName = 'FilterButton';
